module.exports = __webpack_public_path__ + "img/game_verification_1_es.ac156f77.png";